






















import Vue from "vue";

// Vue Component
import DeviceFolderTree from "@/components/DeviceFolderTree.vue";

// Model
import { MoveInstallationInFolderReqData } from "@/model/communication/device/MoveInstallationInFolderReqData";
import { MoveInstallationInFolderCommand } from "@/model/communication/device/MoveInstallationInFolderCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    components: {
        DeviceFolderTree,
    },
    data() {
        return {
            cardLoading: false,
            selectedFolder: null,
        };
    },
    props: {
        installationNamesToMove: Array,
    },
    computed: {
        selectedFolderModel: {
            get() {
                return [this.selectedFolder];
            },
            set(newVal: any) {
                this.selectedFolder = newVal[newVal.length - 1];
            },
        },

        canSave() {
            return this.selectedFolder;
        },
    },
    watch: {
        installationNamesToMove: {
            handler() {
                this.selectedFolder = null;
            },
            deep: true,
        },
    },
    methods: {
        async onSaveButtonClick() {
            if (this.canSave) {
                try {
                    this.cardLoading = true;

                    var req = new MoveInstallationInFolderReqData(this.installationNamesToMove, this.selectedFolder);
                    var res = await new MoveInstallationInFolderCommand(req).execute();

                    if (res.responseStatus == ApiResponseStatusEnum.Success) this.$emit("reload-device-tree", this.selectedFolder);
                    this.$emit("close");
                    this.cardLoading = false;
                } catch (error) {
                    console.error("Error executing MoveInstallationInFolderCommand, message: ", error);
                    this.cardLoading = false;
                }
            }
        },
    },
});
